import { combineReducers } from '@reduxjs/toolkit';
import { listSlice } from './listSlice';
import { editSlice } from './editSlice';
import { registrationSlice } from './registrationSlice';
import { customersSlice } from './customersSlice';

export const releaseTaskReducer = combineReducers({
  list: listSlice.reducer,
  registration: registrationSlice.reducer,
  edit: editSlice.reducer,
  customers: customersSlice.reducer,
});
